// usePendingProposalCount — single source of truth for the
// admin-dashboard "pending review" count. Consumed by:
//   - Sidebar.js (Admin link badge)
//   - AdminDashboard.js (Improvement Requests tab badge)
//   - AdminImprovementRequests.js (card-header pending number)
//
// Bails out without subscribing for non-admins so firestore.rules
// rejections don't spam the console. Listener errors swallowed to
// count=0 (no error UI in the badge — silent failure is preferable
// to a confused-looking error chip).
import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../FirebaseConfig';
import { useAuth } from '../components/auth/AuthContext';

export default function usePendingProposalCount() {
  const { isAdmin } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isAdmin) return undefined;
    const q = query(
      collection(db, 'flagged_call_proposals'),
      where('admin_decision', '==', 'pending'),
    );
    const unsub = onSnapshot(
      q,
      (snap) => setCount(snap.size),
      (err) => {
        console.error('usePendingProposalCount listener error:', err);
        setCount(0);
      },
    );
    return unsub;
  }, [isAdmin]);

  return count;
}
